import { FC, useState } from 'react'

import { AuthPageTemplate } from 'modules/auth/templates'
import { useNavigate } from 'react-router-dom'
import cyanOrangeBg from 'shared/assets/wallpapers/cyan-orange.webp'
import { APP_ROUTES } from 'shared/constants/routes'
import { SessionStorageKey } from 'shared/constants/sessionStorage'
import { validateRedirectUrl } from 'shared/utils/validateRedirectUrl'

import { TwoFaSteps } from './SetupTwoFaPage.constant'
import styles from './SetupTwoFaPage.module.scss'
import {
  SetupTwoFa,
  SetupTwoFaConfirmation,
  SetupTwoFaSuccess
} from './components'

export const SetupTwoFaPage: FC = () => {
  const [currentStep, setCurrentStep] = useState(TwoFaSteps.SETUP_CONFIRMATION)
  const navigate = useNavigate()

  const handleSubmit = () => {
    const storedRedirect = sessionStorage.getItem(
      SessionStorageKey.POST_LOGIN_REDIRECT
    )
    if (storedRedirect) {
      sessionStorage.removeItem(SessionStorageKey.POST_LOGIN_REDIRECT)
      const safeRedirectUrl = validateRedirectUrl(
        storedRedirect,
        APP_ROUTES.desktop.path
      )
      navigate(safeRedirectUrl)
    } else {
      navigate(APP_ROUTES.desktop.path)
    }
  }

  const getStepComponent = () => {
    switch (currentStep) {
      case TwoFaSteps.SETUP_CONFIRMATION:
        return (
          <SetupTwoFaConfirmation
            setCurrentStep={setCurrentStep}
            onSubmit={handleSubmit}
          />
        )
      case TwoFaSteps.SETUP_TWO_FA:
        return <SetupTwoFa setCurrentStep={setCurrentStep} />
      case TwoFaSteps.SETUP_SUCCESS:
        return <SetupTwoFaSuccess onSubmit={handleSubmit} />
      default:
        return null
    }
  }
  return (
    <AuthPageTemplate
      backgroundImageUrl={cyanOrangeBg}
      showHeaderButtons={false}
      backButton={
        currentStep === TwoFaSteps.SETUP_TWO_FA
          ? {
              onClick: () => setCurrentStep(TwoFaSteps.SETUP_CONFIRMATION)
            }
          : undefined
      }
    >
      <div className={styles.setupTwoFaPageContent}>{getStepComponent()}</div>
    </AuthPageTemplate>
  )
}
